import { Badge, BadgeProps } from '@commenda/kakashi';
import { ComplianceModel } from '@commenda/utils';
import { Country, ObligationRulesCategory } from '@prisma/client';

const FilingCategoryBadge = ({
  category,
  country,
  size = 'sm',
}: {
  category: ObligationRulesCategory;
  country: Country;
  size?: BadgeProps['size'];
}) => {
  return (
    <Badge variant="gray" size={size}>
      {ComplianceModel.getFormattedComplianceCategory(category, country)}
    </Badge>
  );
};

export { FilingCategoryBadge };
